module.exports = __webpack_public_path__ + "img/gd.c331fba9.svg";